import { iframeResizer } from 'iframe-resizer';

export default class IFrame {
    constructor() {
        this._items = Array.from(document.querySelectorAll('.iframe__content__inner iframe'));
    }
    render() {
        if (this._items.length) {
            this._items.forEach((item) => {
                this.setupIFrame(item);
            });
        }
    }
    setupIFrame(element) {
        const winId = '#' + element.getAttribute('id');
        try {
            const iframes = iFrameResize({ log: false, minHeight: 300, scrolling: true }, winId);
        } catch (e) {
            console.log(e);
        }
    }
}
